export default "__VITE_ASSET__BGTiOVzJ__"